export const SET_ACTIVE_USER = "SET_ACTIVE_USER";

export const USER_ROLES = Object.freeze({
  ADMIN: 'ADMIN',
  SUPERADMIN: 'SUPERADMIN', 
  USER: 'USER'
});




